import { Card, Icon, IconButton, Toolbar, Tooltip } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import CompanyHelper, { ICompany } from '../../../@types/model/masterData/company';
import { IRootState } from '../../../@types/redux';
import DataFunctions from '../../../store/data/functions';
import MaterialTable from '../../customComponents/materialTable/Table';
import CompanyEditDialog from './components/CompanyEditDialog';
import { getState } from '../../../store';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ConfirmDialog from '../../customComponents/dialog/ConfirmDialog';
import GeneralFunctions from '../../../store/general/functions';

interface ICompanyListProps {
    companies : Array<ICompany>;
    isLoading : boolean;
}

interface ICompanyListState {
    isEditDialogOpen : boolean;
    selectedCompany : ICompany | null;
    companyToDelete : ICompany | null;

}

class CompanyListComponent extends React.PureComponent<ICompanyListProps, ICompanyListState> {
    constructor(props : ICompanyListProps) {
        super(props);
        this.state = {
            isEditDialogOpen: false,
            selectedCompany: null,
            companyToDelete: null,
        };
    }

    private readonly currentUser = getState().auth.session;

    public readonly componentDidMount = () => {
        DataFunctions.getCompanies();
    };

    public readonly handleOpenModal = () : void => {
        this.setState({
            isEditDialogOpen: true,
        });
    };

    public readonly editCompany = (row : ICompany) : void => {
        this.setState({
            selectedCompany: row,
            isEditDialogOpen: true,
        });
    };

    public readonly handleOnDismiss = () => {
        this.setState({
            isEditDialogOpen: false,
            selectedCompany: null,
        });
    };

    public readonly deleteCompany = (row : ICompany) : void => {
        this.setState({
            companyToDelete: row,
        });
    };

    public readonly handleCompanyDelete = async () : Promise<void> => {
        if (!this.currentUser || !this.state.companyToDelete) return;

        const company = CompanyHelper.createInactiveSave(this.currentUser, this.state.companyToDelete);

        try {
            await CompanyHelper.save(company);
            GeneralFunctions.generalShowSuccessSnackbar('Successfully inactivated Company.');
        } catch (e) {
            GeneralFunctions.generalShowErrorSnackbar('An error occurred while inactivating Company.');
        }

        this.setState({
            companyToDelete: null,
        });
    };

    public readonly render = () => {
        const { isLoading, companies } = this.props;
        return (
            <div className={'fdc flx1 p10 mh0 mw0 bcg0'}>
                <div className={'fdc mh0 mw0'}>
                    <Toolbar disableGutters>
                    </Toolbar>
                </div>
                <Card className={'flx1 fdc mb70'}>
                    <MaterialTable<ICompany>
                        id='companiesTable'
                        data={companies}
                        isLoading={isLoading}
                        rowsPerPage={50}
                        externalSort
                        columns={[{
                            header: '',
                            field: 'id',
                            width: 120,
                            fixed: true,
                            renderCell: row => (
                                <div className='aic'>
                                    <Tooltip title='Edit'>
                                        <div>
                                            <IconButton color='primary' onClick={() => this.editCompany(row)}>
                                                <EditIcon />
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                    <Tooltip title='Delete'>
                                        <div>
                                            <IconButton color='primary' disabled={!row.isActive} 
                                                onClick={() => this.deleteCompany(row)}
                                                className={!row.isActive ? '' : 'cr'}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </div>
                            ),
                        }, {
                            header: 'Code',
                            field: 'code',
                            width: 145,
                            enableSort: true,
                            enableFilter: true,
                        }, {
                            header: 'Name',
                            field: 'name',
                            width: 145,
                            enableSort: true,
                            enableFilter: true,
                        }, {
                            header: 'VAT GL Account',
                            field: 'vatAccountNumber',
                            width: 145,
                            enableSort: true,
                            enableFilter: true,
                        }, {
                            header: 'Electricity GL Account',
                            field: 'electricityAccountNumber',
                            width: 180,
                            enableSort: true,
                            enableFilter: true,
                        }, {
                            header: 'Interest GL Account',
                            field: 'interestAccountNumber',
                            width: 160,
                            enableSort: true,
                            enableFilter: true,
                        }, {
                            header: 'Payment Enabled',
                            field: 'paymentEnabled',
                            width: 150,
                            enableSort: true,
                            enableFilter: true,
                            renderCell: n => !n.paymentEnabled ? (<Icon className='cr aic'>close</Icon>) : (<Icon className='cdg aic'>check</Icon>),
                        },
                        {
                            header: 'Is Active',
                            field: 'isActive',
                            width: 150,
                            enableSort: true,
                            renderCell: n => !n.isActive ? (<Icon className='cr'>close</Icon>) : (<Icon className='cdg'>check</Icon>),
                        },
                        {
                            header: 'Created By',
                            field: 'createdByName',
                            width: 145,
                            enableSort: true,
                            enableFilter: true,
                            renderCell: row => (
                                <Tooltip title={row.createdByEmployee}>
                                    <div>
                                        {
                                            row.createdByName
                                        }
                                    </div>
                                </Tooltip>
                            ),
                        }, {
                            header: 'Updated By',
                            field: 'updatedByName',
                            width: 145,
                            enableSort: true,
                            enableFilter: true,
                            renderCell: row => (
                                <Tooltip title={row.updatedByEmployee}>
                                    <div>
                                        {
                                            row.updatedByName
                                        }
                                    </div>
                                </Tooltip>
                            ),
                        }]}
                    />
                </Card>
                <div className='fdr jcfe'>
                    <div className={'fdrr mt15 mr15'}>
                        {
                            !isLoading &&
                            <Tooltip title='Create'>
                                <div>
                                    <IconButton onClick={this.handleOpenModal} className={'bcy'}>
                                        <Icon className={'cp'}>
                                            add
                                        </Icon>
                                    </IconButton>
                                </div>
                            </Tooltip>
                        }
                    </div>
                    {
                        this.state.isEditDialogOpen && 
                        <CompanyEditDialog 
                            currentUser={this.currentUser} 
                            companies={this.props.companies}
                            isOpen={this.state.isEditDialogOpen}
                            selectedCompany={this.state.selectedCompany}
                            onDismiss={this.handleOnDismiss}
                        />
                    }
                    {
                        !!this.state.companyToDelete &&
                            <ConfirmDialog 
                                open={!!this.state.companyToDelete}
                                title={'Delete Value Added Tax'}
                                message={'Are you sure you want to inactivate the selected entry?'}
                                onAccept={this.handleCompanyDelete}
                                onClose={() => this.setState({
                                    companyToDelete: null,
                                })}
                            />
                    }
                </div>
            </div>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return {
        isLoading: state.data.isLoadingCompanies,
        companies: state.data.companies,
    };
};

const CompanyList = connect(
    mapStateToProps,
)(CompanyListComponent);

export default CompanyList;
